import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatGridListModule } from '@angular/material/grid-list';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ConnectionIconModule } from '../../shared/cell-renderers/connection-icon/connection-icon.module';
import { ConfirmDialogModule } from '../confirm-dialog/confirm-dialog.module';
import { MetricTreeItemComponent } from './tree-items/metric-tree-item/metric-tree-item.component';
import { TreeRowValueComponent } from './tree-items/tree-row-value/tree-row-value.component';
import { TreeComponent } from './tree.component';
import { RealtimeDataService } from './realtime-data.service';
import { TreeModule as PrimeTree } from 'primeng/tree';

@NgModule({
    declarations: [TreeComponent, MetricTreeItemComponent, TreeRowValueComponent],
    imports: [
        CommonModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,
        MatCheckboxModule,
        MatGridListModule,
        FormsModule,
        PrimeTree,
        ConnectionIconModule,
        ConfirmDialogModule,
    ],
    providers: [
        RealtimeDataService
    ],
    exports: [TreeComponent, MetricTreeItemComponent, TreeRowValueComponent]
})

export class TreeModule { }